import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@core/hooks/appHooks';
import { selectUser, setUser } from '@core/store/userSlice/userSlice';
import { useAuth } from '@providers/authProvider';

import pkg from '../../../package.json';
import LoadingAircraft from './LoadingAircraft';

interface Props {
  onSuccess: () => void;
}

const LoadingAuth: React.FC<Props> = ({ onSuccess }) => {
  const CSSBlock = 'loading-auth';
  const [hide, setHide] = useState(false);

  const elements = [
    { weight: 400, char: 'w' },
    { weight: 400, char: 'i' },
    { weight: 400, char: 'n' },
    { weight: 400, char: 'g' },
    { weight: 400, char: 'm' },
    { weight: 400, char: 'a' },
    { weight: 700, char: 'n' },
    // { weight: 700, char: 'n' },
  ];

  useEffect(() => {
    setTimeout(() => {
      // onAnimStart && onAnimStart();
      setHide(true);
      setTimeout(() => onSuccess(), 500);
    }, 2400);
  }, []);

  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const { userAccount } = useAuth();

  useEffect(() => {
    // console.log('USERACCOUNT changed', userAccount?.uid);
    // dispatch(setUser(userAccount));
    // if (!userAccount) {
    //   return;
    // }
    setTimeout(() => {
      dispatch(setUser(user));
    }, 2000);
    // getUser(userAccount!.uid)
    //   .then(user => {
    //     console.log('user:', user);
    //   })
    //   .catch(e => {
    //     dispatch(setUser(undefined));
    //     console.error("User doesn't exist:", e);
    //   });
  }, [user]);

  return (
    <div className={`${CSSBlock} ${hide ? `${CSSBlock}--hide` : ''}`}>
      {/* <div className={`${CSSBlock}__background`}></div> */}
      <div className={`${CSSBlock}__title`}>
        {elements.map((el, i) => (
          <span
            key={i}
            className={`${CSSBlock}__title-text`}
            style={
              {
                // fontWeight: el.weight,
                // animationDelay: `${0.2 * i}s`,
              }
            }>
            {el.char}
          </span>
        ))}
        <div className={`${CSSBlock}__subtitle`}>Loading User Profile</div>
      </div>
      <div className={`${CSSBlock}__version`}>
        v{pkg.version} alpha - {pkg.date}
      </div>
      {/* <LoadingAircraft animated /> */}
    </div>
  );
};

export default LoadingAuth;
